<div class="cookie-banner" *ngIf="showBanner">
  <!-- Ultra Minimal View - Just a Cookies button -->
  <div class="cookie-button" *ngIf="!showDetails && !showPreferences" (click)="showDetails = true">
    {{ translate('cookies.buttonText') || 'Cookies' }}
  </div>
  
  <!-- Detailed View Container -->
  <div class="cookie-banner-container" *ngIf="showDetails || showPreferences">
    <button class="btn-close" (click)="closeDetails()" aria-label="Close">×</button>
    
    <!-- Detailed View -->
    <div class="cookie-banner-main" *ngIf="showDetails && !showPreferences">
      <div class="cookie-banner-content">
        <h2>{{ translate('cookies.title') || 'Cookie Consent' }}</h2>
        <p>{{ translate('cookies.description') || 'We use cookies to improve your experience on our website. Some cookies are necessary for the website to function properly, while others help us understand how you interact with our site and allow us to improve it.' }}</p>
        <p>{{ translate('cookies.moreInfo') || 'For more information, please read our Cookie Policy.' }}</p>
      </div>
      <div class="cookie-banner-actions">
        <button class="btn-secondary" (click)="togglePreferences()">
          {{ translate('cookies.customize') || 'Customize' }}
        </button>
        <button class="btn-outline" (click)="acceptNecessaryOnly()">
          {{ translate('cookies.acceptNecessary') || 'Accept Necessary Only' }}
        </button>
        <button class="btn-primary" (click)="acceptAll()">
          {{ translate('cookies.acceptAll') || 'Accept All' }}
        </button>
      </div>
    </div>
    
    <div class="cookie-banner-preferences" *ngIf="showPreferences">
      <div class="cookie-banner-content">
        <h2>{{ translate('cookies.preferences') || 'Cookie Preferences' }}</h2>
        <p>{{ translate('cookies.preferencesDescription') || 'You can customize your cookie preferences here. Necessary cookies are always enabled as they are essential for the website to function properly.' }}</p>
        
        <div class="cookie-category">
          <div class="cookie-category-header">
            <h3>{{ translate('cookies.necessary.title') || 'Necessary Cookies' }}</h3>
            <label class="switch">
              <input type="checkbox" checked disabled>
              <span class="slider round"></span>
            </label>
          </div>
          <p>{{ translate('cookies.necessary.description') || 'These cookies are essential for the website to function properly and cannot be disabled.' }}</p>
        </div>
        
        <div class="cookie-category">
          <div class="cookie-category-header">
            <h3>{{ translate('cookies.analytics.title') || 'Analytics Cookies' }}</h3>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="analyticsEnabled">
              <span class="slider round"></span>
            </label>
          </div>
          <p>{{ translate('cookies.analytics.description') || 'These cookies help us understand how visitors interact with our website, allowing us to improve it.' }}</p>
        </div>
        
        <div class="cookie-category">
          <div class="cookie-category-header">
            <h3>{{ translate('cookies.marketing.title') || 'Marketing Cookies' }}</h3>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="marketingEnabled">
              <span class="slider round"></span>
            </label>
          </div>
          <p>{{ translate('cookies.marketing.description') || 'These cookies are used to track visitors across websites to display relevant advertisements.' }}</p>
        </div>
        
        <div class="cookie-category">
          <div class="cookie-category-header">
            <h3>{{ translate('cookies.preferences.title') || 'Preferences Cookies' }}</h3>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="preferencesEnabled">
              <span class="slider round"></span>
            </label>
          </div>
          <p>{{ translate('cookies.preferences.description') || 'These cookies enable personalized features and functionality on our website.' }}</p>
        </div>
      </div>
      
      <div class="cookie-banner-actions">
        <button class="btn-secondary" (click)="togglePreferences()">
          {{ translate('cookies.back') || 'Back' }}
        </button>
        <button class="btn-primary" (click)="savePreferences()">
          {{ translate('cookies.savePreferences') || 'Save Preferences' }}
        </button>
      </div>
    </div>
  </div>
</div>
